import type { FC } from 'react'
import type { Product } from '@model/product'
import { ProductSlider } from '@components/product'
import { useRouter } from 'next/router'
import type { Locale } from '@model/locales'
import { KK_LANG_IDS } from '@model/locales'
import useSWRImmutable from 'swr/immutable'
import type { ProductSearchResult } from '@model/product'
import type { HTMLAttributes, PropsWithChildren } from 'react'

interface W2ProductsProps extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
  products: string
}

export const W2Products: FC<W2ProductsProps> = ({ products, className }) => {
  const { locale } = useRouter()
  const languageId = KK_LANG_IDS[locale as Locale]
  const queryParams = new URLSearchParams()

  queryParams.set('skuList', products.trim())
  queryParams.set('languageId', `${languageId}`)

  const { data } = useSWRImmutable<ProductSearchResult>(
    products ? `/api/products-by-sku?${queryParams.toString()}` : null
  )

  const productList: Product[] = data?.productArray || []

  if (!data || !productList.length) return null

  return (
    <div className={className}>
      <ProductSlider listName="product_category" products={productList} />
    </div>
  )
}
